import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

// wizardclose=true is set when the import wizard is cancelled; the ImportRefuelings list
// (rendered by the parent layout route) reads it from the URL and shows a cancel toast.
const importRecordSearchSchema = z.object({
  wizardclose: z.boolean().optional().catch(undefined),
});

export const Route = createFileRoute('/_authenticated/expenses_import/expense/import/record/')({
  validateSearch: importRecordSearchSchema,
  // The list is always rendered by the parent layout route.
  component: () => null,
});
